import type { FunctionComponent } from 'react';
import React from 'react';
import { motion } from 'framer-motion';

import { Direction } from '../../../../steps/types/step';

export interface StepAnimationContainerProps {
  direction: Direction;
}

/**
 * Adds horizontal transition animation to the step.
 */
export const StepAnimationContainer: FunctionComponent<StepAnimationContainerProps> = ({ children, direction }) => {
  return (
    <motion.div
      custom={direction}
      variants={{
        enter: (direction: Direction) => {
          return {
            x: direction === Direction.Right ? 1000 : -1000,
          };
        },
        center: {
          zIndex: 1,
          x: 0,
        },
        exit: (direction: Direction) => {
          return {
            zIndex: 0,
            x: direction === Direction.Right ? -1000 : 1000,
          };
        },
      }}
      transition={{
        x: { type: 'spring', stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 },
      }}
    >
      {children}
    </motion.div>
  );
};
